import PropTypes from 'prop-types';
import React from 'react';
import Button from '@material-ui/core/Button';
import { withStyles } from '@material-ui/core/styles';
import { globalStyles } from './style/gstheme';

const styles = () => {
    return Object.assign({
        cancelButton: {
            fontSize: '16px',
            color: '#13294B',
            padding: '6px 16px'
        }
    }, globalStyles);
};

class CancelButton extends React.PureComponent {

    render() {

        const { classes, dataTest, disabled } = this.props;

        return (
            <Button
                disabled={disabled}
                variant="text"
                data-test={dataTest || "cancel-button"}
                onClick={this.props.onClick}
                className={classes.cancelButton}>
                {this.props.children || "Cancel"}
            </Button>
        );
    }
}

CancelButton.defaultProps = {
    disabled: false
};

CancelButton.propTypes = {
    dataTest: PropTypes.string,
    disabled: PropTypes.bool,
    onClick: PropTypes.func.isRequired,
    children: PropTypes.any,
    classes: PropTypes.object
};

export default withStyles(styles)(CancelButton);